/**
 * Compliance state coverage page path.
 * Served as static HTML in production (nginx) at /compliance on each ICP host:
 *   - Production: https://icp.ksp1446.com/compliance
 *   - QA:         https://icp.kipuqa.com/compliance
 *   - UAT:        https://icp.kipuuat.com/compliance
 */
export const COMPLIANCE_COVERAGE_PATH = '/compliance';
export const COMPLIANCE_COVERAGE_LINK_TEXT = 'View state coverage details';
